import React, { useRef } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Editor } from 'draft-js';
import { richEditorStyles } from './styles';
import EditorToolbar from './EditorToolbar';
import classNames from 'classnames';
import { getCustomStyleMap, extractInlineStyle } from 'draftjs-utils';
import { getBlockStyle, handleTab, styleOverride, blockRenderer } from './utils';

function RichContent (props) {

    const { editorState, preview, placeholder, classes, onChange, disabled } = props;

    const ref = useRef(null);

    extractInlineStyle(editorState);

    const handleCustom = (editorState) => onChange(styleOverride(editorState));

    const onTab = (e) => {
        e.preventDefault();
        if (!preview) onChange(handleTab(e, editorState));
    };

    const handleFocus = () => ref.current.focus()
    
    const containerStyle = preview ? classes.draftEditor : classes.container;
    
    const className = classNames({ [classes.editorStyle]: !preview }) 

    const blockRendererFunction = (block) => blockRenderer(block, editorState);
    
    return (
        <div className={containerStyle}>
            {!preview && <EditorToolbar
                editorState={editorState}
                handleChange={onChange}
                handleCustom={handleCustom}
                handleFocus={handleFocus}
            />}
            <div className={className} onClick={handleFocus} >
                <Editor
                    readOnly={preview || disabled}
                    onTab={onTab}
                    ref={ref}
                    placeholder={placeholder || ''}
                    editorState={editorState}
                    onChange={onChange}
                    blockStyleFn={getBlockStyle}
                    customStyleMap={getCustomStyleMap()}
                    blockRendererFn={blockRendererFunction}
                />
            </div>
        </div>
    )
};

export default withStyles(richEditorStyles)(RichContent);